<template>
    <div class="main-review-container">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(list, index) in lists" class="swiper-slide">
                    <a class="main-review">
                        <span class="main-review__thumb">
                            <span class="main-review__thumbnail">
                                <span class="main-review__thumbnail-image" style="background-image:url('/images/sample/product-thumbnail-medium.jpg')"></span>
                            </span>
                            <span class="main-review__thumb-image"></span>
                        </span>
                        <div class="main-review__contents">
                            <span class="main-review__name"><b>홍X동{{index+1}}</b> 고객님<small>홈씨씨인테리어</small></span>
                            <ul class="main-review__tags">
                                <li class="main-review__tag">아파트</li>
                                <li class="main-review__tag">종합</li>
                                <li class="main-review__tag">40평</li>
                                <li class="main-review__tag">2300만</li>
                            </ul>
                            <div class="main-review__rating">
                                <!-- 별점 평가 -->
                                <div class="star-rating-container">
                                    <span class="star-rating">
                                        <span class="star star--on"></span>
                                    </span>
                                    <span class="star-rating">
                                        <span class="star star--on"></span>
                                    </span>
                                    <span class="star-rating">
                                        <span class="star star--on"></span>
                                    </span>
                                    <span class="star-rating">
                                        <span class="star star--on"></span>
                                    </span>
                                    <span class="star-rating">
                                        <span class="star"></span>
                                    </span>
                                </div>
                                <span class="main-review__rating-point">4.0</span>
                            </div>
                            <p class="main-review__pr">인테리어회사가 같은 건물이라 서로 편한것도 있었지만 왠지  껄끄러워 질까봐 조심스러운 부분도 있었는데 그래도 원만히  해결되었다. 인테리어 1도 모르는데 이번 경험을 계기로 좀 더 알게된 부분도 있고 이렇게 경험치 증가!</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="main-review__pagination"></div>
        <div class="main-review__prev"></div>
        <div class="main-review__next"></div>
        <div class="main-review-back"></div>
    </div>
</template>

<script>
export default{
	components: {
	},
    data: () => {
        return{
            lists: new Array(5),
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
            this.$nextTick( () => {
                var slideReview = new Swiper ('.main-review-container .swiper-container', {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: true,
                    spaceBetween : 0,
                    // autoplay: {
                    //     delay: 3000,
                    //     stopOnLastSlide: true,
                    //     disableOnInteraction: false,
                    // },
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: '.main-review__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-review__next',
                        prevEl: '.main-review__prev'
                    },
                });
            });
		}
	},
}
</script>
